export default "__VITE_ASSET__Dcxu39ep__"